module.exports = __webpack_public_path__ + "static/cradle-b5ebcf874b29622496210a2527ede66a.png";